<template>
  <EstateManageOverviewSkeleton />
</template>

<script>
import EstateManageOverviewSkeleton from '/@/modules/estate/components/manage/skeletons/EstateManageOverviewSkeleton.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ExitingEstateSkeleton',
  components: { EstateManageOverviewSkeleton }
};
</script>
